export default {"src":"/_next/static/media/25-icon.ade474b8.svg","height":46,"width":28,"blurWidth":0,"blurHeight":0};